import { CultivoViewModel } from '../cultivos/cultivo.types';
export class TwUnidadInspeccionViewModelBase {
    public IdUi?: number;
    public IdEstadoUi?: number;
    public EstadoUi: string;
    public CodigoUhc: string;
    public IdTipoSolicitudCam?: number;
    public IdUsuario?: number;
    public PeriodoCertificaKgs: boolean;
}

export class TwUnidadInspeccionViewModel extends TwUnidadInspeccionViewModelBase {
    public RecintoUnidadInspeccionListIds: number[]; // Ids de TwRecintoUnidadInspeccion
}

export class TwUnidadInspeccionViewModelExtended extends TwUnidadInspeccionViewModelBase {
    public FirstRecinto: TwRecintoUnidadInspeccionViewModel;
}

export class TwRecintoUnidadInspeccionViewModel {
    public IdPeriodo: number;
    public IdTipoSolicitudCam: number;
    public PeriodoEnPlazoVigente: boolean;
    public IdCampania: number;
    public Campania: string;
    public Periodo: string;
    public DescripcionComunidad: string;
    public EntidadAuditora: string;
    public TipoRecinto: string;
    public OperadorRazonSocial: string;
    public IdCa: number;
    public IdEntidadAuditora: number;
    public IdOperador: number;
}

export class ComentarioUICamViewModel {
    public Id?: number;
    public IdUsuario?: number;
    public Usuario: string;
    public IdUnidadInspeccionCam: number;
    public Fecha?: Date;
    public Observaciones: string;
}

export class TwCorteCultivoCamViewModel {
    public Id: number;
    public Codigo: string;
    public IdCultivo: number;
    public SuperficieVariedad: number;
    public ProduccionEstimadaVariedad: number;
    public IdAforoCultivo: number;
    public IdUi: number;
    public IdAlmacen: number;
    public Almacen?: string;
    public KgsAutorizados: number;
    public FechaCaducidad?: Date | string;
    public IdUsuario?: number;
    public FechaCreacion?: Date;
    public IdUsuarioModificacion?: number;
    public FechaModificacion?: Date;
    public Exportador: string;
    public IdUsuarioBorrado?: number;
    public FechaBorrado?: Date;
}
export class TwAforoCultivoCamViewModel {
    public Id: number;
    public IdCultivo: number;
    public Anyo: number;
    public Mes: number;
    public Descripcion: string;
    public KgsProduccionEstimada: number;
    public KgsProduccionReal: number;
    public KgsAcumuladosCorte?: number; // Campo calculado en back-end
    public IdUsuario: number;
    public FechaCreacion: Date;
    //
    public CultivoSelected?: CultivoViewModel;
}

export class DocumentoUICamViewModel {
    public Id?: number;
    public IdUsuario?: number;
    public Usuario: string;
    public IdUnidadInspeccion: number;
    public FechaCreacion?: Date;
    public Descripcion: string;
    public NombreArchivo: string;
    public CodigoStorage: string;
    public FileSize: number;
    public MarkToDelete?: number;
}

export class CultivosAforosViewModel {
    public IdUi: number;
    public CodigoUhc: string;
    public IdCultivo: number;
    public IdVariedad: number;
    public CodigoSigPacRecinto: string;
    public IdentificadorCultivo: string;
    public Variedad: string;
    public Superficie: number;
    public IdAforo?: number;
    public AforoDescripcion?: string;
    public KgsProduccionEstimada?: number;
    public KgsProduccionReal?: number;
    public KgsProduccionRestante?: number;
    public cortesCultivos: TwCorteCultivoCamViewModel[];
}
